export default "__VITE_ASSET__BxSYH1cD__"